import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bh-what-we-treat',
  templateUrl: './bh-what-we-treat.html'
})



export class BHWhatWeTreat  {

  constructor(private router: Router) {   }
  
  // continue(){
  //   this.router.navigateByUrl('/dashboard-medical/2');
  // }
  requestExam(){
		this.router.navigateByUrl('/exam-request-care-today');
  }
  
  gotoDashboard() {
		this.router.navigate(['/dashboard-medical/2']);
	}

}